module.exports = __webpack_public_path__ + "img/added-tojob.175dcb9b.svg";